import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { UtilisateurCourantService } from '../../../services/utilisateurs/utilisateur-courant.service';
import { IfAuthorizedAbstractDirective } from './if-authorized-abstract.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ifAuthorizedActif]',
})
export class IfAuthorizedActifDirective extends IfAuthorizedAbstractDirective implements OnDestroy {
  constructor(
    viewContainerRef: ViewContainerRef,
    templateRef: TemplateRef<any>,
    utilisateurCourantService: UtilisateurCourantService,
  ) {
    super(viewContainerRef, templateRef, utilisateurCourantService);
    this.forActif();
  }

  @Input('ifAuthorizedActifElse') set ifAuthorizedActifElse(value: TemplateRef<any>) {
    this.elseTemplate = value;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  @Input() set ifAuthorizedActif(value: string | number) {
    this.fonctionLogicielle = value;
  }
}
